import React, { useState, useEffect, useRef } from 'react';
import DataTypeInstructions from "../Retro/DataTypeInstructions";
import Uploader from "./Uploader";
import { useJobContext } from "../../contexts/job";
import { getInstructionsConfig } from '../Retro/instructions';


function ScreenCaptureBlock({block}) {
  const {platform, lang, goNext} = useJobContext();

  const [currentlyShowingUploader, setCurrentlyShowingUploader] = useState(false);
  const [uploadAttempts, setUploadAttempts] = useState(0);
  const hasCalledGoNext = useRef(false);

  const collectionMode = block.screen_capture.collection_mode;
  const configDetails = getInstructionsConfig(block.screen_capture.data_type,platform,lang,  {
    showSimpleInstructions: true,
    collectionMode,
  })
  const fileSource = configDetails?.file_source || 'default';

  // Determine what to show based on block configuration
  const shouldShowInstructions = block.screen_capture.show_instructions !== false;
  const shouldShowUploader = block.screen_capture.show_uploader !== false;

  // If both instructions and uploader are disabled, advance to the next page (only once)
  useEffect(() => {
    if (!shouldShowInstructions && !shouldShowUploader && !hasCalledGoNext.current) {
      hasCalledGoNext.current = true;
      goNext();
    }
  }, [shouldShowInstructions, shouldShowUploader, goNext]);

  const showUploader = () => {
    setCurrentlyShowingUploader(true);
  };

  const showInstructions = () => {
    setCurrentlyShowingUploader(false);
  };

  // If neither instructions nor uploader should be shown, render nothing while advancing
  if (!shouldShowInstructions && !shouldShowUploader) {
    return null;
  }

  if (currentlyShowingUploader || !shouldShowInstructions) {
    return (
      <Uploader
        block={block}
        showInstructions={shouldShowInstructions ? showInstructions : null}
        uploadAttempts={uploadAttempts}
        setUploadAttempts={setUploadAttempts}
        fileSource={fileSource}
      />
    );
  } else {
    return (
      <DataTypeInstructions
        dataType={block.screen_capture.data_type}
        platform={platform}
        lang={lang}
        showUploader={showUploader}
        isWebClient={true}
        collectionMode={collectionMode}
      />
    )
  }
}

export default ScreenCaptureBlock;
